import { render, staticRenderFns } from "./SlideEditor.vue?vue&type=template&id=6160bc06&scoped=true&"
import script from "./SlideEditor.vue?vue&type=script&lang=ts&"
export * from "./SlideEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160bc06",
  null
  
)

export default component.exports